module.exports = __webpack_public_path__ + "img/container1Model.c2db791c.png";